import { toDateTime } from '@agroone/dates'

export class Reporting {
  createdAt?: string
  updatedAt?: string
  createdBy?: number | null
  updatedBy?: number
}

export class ReportingDAO {
  createdAt?: string
  updatedAt?: string
  createdBy?: number
  updatedBy?: number

  constructor(reporting: Pick<Reporting, 'createdBy' | 'updatedBy'>) {
    if (reporting.createdBy) {
      this.createdBy = reporting.createdBy
      this.createdAt = toDateTime()
    }

    if (reporting.updatedBy) {
      this.updatedBy = reporting.updatedBy
      this.updatedAt = toDateTime()
    }
  }
}
